import { useCallback } from "react"

import { useRoadsideTypes } from "../queries/useRoadsideTypes"

function findCodeIndex(code, catalog, depth) {
    const codeIndex = catalog.findIndex(item => item.code === code)

    if (codeIndex >= 0) {
        return depth
    } else {
        for (const item of catalog) {
            const codeDepth = findCodeIndex(code, item.children, depth + 1)
            if (codeDepth >= 0) {
                return codeDepth
            }
        }

        return -1
    }
}

export function findRoadsideTypeByCode(code, catalog) {
    const roadsideType = catalog.find(item => item.code === code)

    if (roadsideType) {
        return roadsideType
    } else {
        for (const item of catalog) {
            const type = findRoadsideTypeByCode(code, item.children)
            if (type) {
                return type
            }
        }

        return null
    }
}

export function useGetRoadsideTypeCatalogUtils() {
    const { data: roadsideTypes } = useRoadsideTypes()

    const getRoadsideTypeDepth = useCallback((code) => {
        if (!roadsideTypes) {
            return -1
        }

        return findCodeIndex(code, roadsideTypes, 0)
    }, [roadsideTypes])

    const getRoadsideTypeChildren = useCallback((code) => {
        if (!roadsideTypes) {
            return []
        }

        const roadsideType = findRoadsideTypeByCode(code, roadsideTypes)
        return roadsideType ? roadsideType.children : []
    }, [roadsideTypes])

    return {
        getRoadsideTypeDepth,
        getRoadsideTypeChildren,
    }
}